import React from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";

// Tabla de KPIs por año (Pantalla 3, reutilizada en Pantalla 2): los 5 KPIs
// del header, uno por año, con `anioPrincipal` resaltado y una fila final
// "Consolidado" (`consolidado`). `metrica` ("monto" por defecto, Pantalla 3
// no tiene toggle) formatea Venta total/Factura promedio como cantidad
// ("1,234 unidades") en vez de dinero cuando la pantalla que la use tenga
// el toggle Monto/Cantidad (Pantalla 2) en "cantidad".
export const TablaKpisPorAnio = ({ filas = [], anioPrincipal, consolidado, metrica = "monto" }) => {
    const esCantidad = metrica === "cantidad";
    const formatVenta = (valor) =>
        esCantidad ? `${Math.round(valor).toLocaleString("es-MX")} unidades` : `$${FormatMoney(valor, 0)}`;

    return (
        <div className="tabla-kpis-anio">
            <div className="tabla-kpis-anio-header">
                <span>Año</span>
                <span>{esCantidad ? "Cantidad total" : "Venta total"}</span>
                <span>Repetitividad</span>
                <span>{esCantidad ? "Cant. x factura" : "Factura prom."}</span>
                <span>Meses activos</span>
                <span>Margen</span>
            </div>
            <div className="tabla-kpis-anio-body scroll">
                {filas.length === 0 && (
                    <div className="tabla-kpis-anio-vacio">Sin datos para los años mostrados.</div>
                )}
                {filas.map((fila) => (
                    <div
                        key={fila.anio}
                        className={`tabla-kpis-anio-row${String(fila.anio) === String(anioPrincipal) ? " tabla-kpis-anio-row--principal" : ""
                            }`}
                    >
                        <span>{fila.anio}</span>
                        <span>{formatVenta(fila.ventaTotal)}</span>
                        <span>{fila.repetitividad.toFixed(2)}</span>
                        <span>{formatVenta(fila.facturaPromedio)}</span>
                        <span>{fila.mesesActivos}</span>
                        <span>{(fila.margen * 100).toFixed(1)}%</span>
                    </div>
                ))}
                {consolidado && (
                    <div className="tabla-kpis-anio-row tabla-kpis-anio-row--consolidado">
                        <span>total</span>
                        <span>{formatVenta(consolidado.ventaTotal)}</span>
                        <span>{consolidado.repetitividad.toFixed(2)}</span>
                        <span>{formatVenta(consolidado.facturaPromedio)}</span>
                        <span>{consolidado.mesesActivos}</span>
                        <span>{(consolidado.margen * 100).toFixed(1)}%</span>
                    </div>
                )}
            </div>
        </div>
    );
};
